var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplaceFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2848 4.00001C10.7079 3.99833 9.16756 4.48281 7.867 5.38951C6.56645 6.29621 5.56682 7.58253 5 9.07874L6.20792 9.5814C6.62342 8.4759 7.32338 7.50421 8.23463 6.76792C9.14587 6.03162 10.2349 5.55776 11.3879 5.39589C12.5409 5.23402 13.7155 5.39008 14.7889 5.84776C15.8623 6.30543 16.795 7.04791 17.4896 7.99756H14.9059V9.32059H19.4903V4.65915H18.1891V6.72194C17.4534 5.86565 16.5457 5.17963 15.5272 4.71009C14.5087 4.24056 13.4031 3.99843 12.2848 4.00001ZM18.3664 14.4325C17.9009 15.6853 17.0716 16.7644 15.9887 17.5267C14.9058 18.2889 13.6205 18.6983 12.3035 18.7004C11.2854 18.691 10.2834 18.4416 9.37621 17.9717C8.46902 17.5019 7.68143 16.8244 7.07538 15.9926H9.66377V14.6649H5.09794V19.3311H6.39913V17.2777C7.28486 18.3098 8.41789 19.0916 9.68831 19.5473C10.9587 20.003 12.3234 20.1171 13.65 19.8785C14.9766 19.64 16.22 19.0568 17.2596 18.1857C18.2992 17.3146 19.0998 16.1851 19.5836 14.9067L18.3757 14.4325H18.3664Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceFile);
export default __webpack_public_path__ + "static/media/replace_file.728eb48f4d293355bd6e1a0a1ba958ba.svg";
export { ForwardRef as ReactComponent };